import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class ImageService {

    listImages(data, folder) {
        return axiosInstance.get(`${config.api.version}/image/${data}/folder/${folder}`);
    }

    uploadAvatar(data, image) {
        return axiosInstance.post(`${config.api.version}/image/${data}/avatar`, image, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    uploadMultiple(data, images) {
        return axiosInstance.post(`${config.api.version}/image/${data}/upload-multiple`, images, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    deleteMultiple(data, images) {
        return axiosInstance.post(`${config.api.version}/image/${data}/delete-multiple`, images);
    }

}
